export default __webpack_public_path__ + "51d19b05344ab0893b6986c75819a114.png";